import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import Tabs from '../../../../Template/layoutComponents/Tabs';

import HistoryTab from '../../../../Template/layoutComponents/HistoryTab';
import GeneralTab from '../../../../Template/layoutComponents/GeneralTab';

import { getDepartments, updateDepartment } from '../../../../Maintenance/helpers/apiCalls';
import { useMsal } from '@azure/msal-react';
import useMaintenanceState from '../../../../Maintenance/atoms/variables';
import useSettingsState from '../../../atoms/variables';
import useGlobalState from '../../../../Template/atoms/variables';
import { notification } from 'antd';

const Details = () => {
  const { t } = useTranslation();
  const { categoryId } = useParams();

  const [notificationApi, contextHolder] = notification.useNotification();
  const { instance } = useMsal();

  const { setPendingApiCalls } = useGlobalState();
  const { setDepartments } = useMaintenanceState();
  const { viewDetailsCategory, setViewDetailsCategory } = useSettingsState();

  useEffect(() => {
    if (!viewDetailsCategory) {
      triggerApiCalls();
    }
  }, []);

  const triggerApiCalls = async () => {
    try {
      setPendingApiCalls((current) => current.concat(['getDepartments']));

      const response = await getDepartments(instance);
      setDepartments(response);
      setViewDetailsCategory(response?.find((o) => o.id === categoryId || o._id === categoryId));
    } catch (err) {
      notificationApi.error({
        message: t('database_communication_failure'),
        description: err?.response?.data?.message
          ? `${err?.response?.data?.message} (${err?.response?.status})`
          : err?.message,
        duration: 5,
      });
    } finally {
      setPendingApiCalls((current) => current.filter((item) => item !== 'getDepartments'));
    }
  };

  return (
    <div id='categoryDetails'>
      <Tabs
        tabs={[
          {
            label: t('general_tab'),
            content: (
              <GeneralTab detailsLink={'/settings/departments'} updateItem={updateDepartment} />
            ),
            disabled: false,
          },
          {
            label: t('history_tab'),
            content: <HistoryTab id={categoryId} />,
            disabled: false,
          },
        ].filter((tab) => tab)}
      />
    </div>
  );
};

export default Details;
